export default {
    en: {
        required_field                : "This field it is required",
        display_name                  : "Display Name",
        display_name_placeholder      : "Enter your name",
        email_address                 : "Email Address",
        notification_method           : "Notification Method",
        push_notification             : "Push Notification",
        sms                           : "SMS",
        phone_number                  : "Phone Number",
        phone_number_placeholder      : "3069xxxxxxxx",
        phone_number_format_validation: "Please enter a phone number with the format: 3069xxxxxxxxx",
        role                          : "Role",
        role_partner                  : "Agent",
        role_administrator            : "Administrator"
    },
    el: {
        required_field                : "Αυτό το πεδίο είναι απαραίτητο",
        display_name                  : "Εμφανιζόμενο Όνομα",
        display_name_placeholder      : "Πληκτρολογήστε το όνομα σας",
        email_address                 : "Διεύθυνση Ηλεκτρονικού Ταχυδρομείου",
        notification_method           : "Τρόπος Ειδοποίησης",
        push_notification             : "Ειδοποιήσεις στον Browser σας",
        sms                           : "SMS",
        phone_number                  : "Τηλέφωνο",
        phone_number_placeholder      : "+3069xxxxxxxx",
        phone_number_format_validation: "Παρακαλώ πληκτρολογίστε ένα αριθμό με την ακόλουθη μορφή: +3069xxxxxxxxx",
        role                          : "Ρόλος",
        role_partner                  : "Μεσίτης",
        role_administrator            : "Διαχειριστής"
    }
};